export default __webpack_public_path__ + "static/media/bar_placeholder.e945c550.svg";